<template>
	<el-dialog title="电销记录" :visible="visible" :width="pageMode ? '96%' : '900px'" :top="pageMode ? '3vh' : '15vh'"
		append-to-body :close-on-click-modal="false" :show-close="!pageMode" :close-on-press-escape="!pageMode" @close="onClose">
		<div class="tsd-body" v-loading="loading">
			<div class="tsd-tip">
				<i class="el-icon-info"></i>
				<span>交叉电销：自己接待的订单不在此显示。池塘由管理员/财务查看并分配给业务员（不能分配给接待过的人）；被分配后到「我的电销」拨打；未成交填完记录仍留在自己列表继续跟进，不需要时点「退回池塘」；成交的留在自己列表。</span>
			</div>
			<el-tabs v-model="tab" @tab-click="onTabClick()">
				<el-tab-pane label="电话会话" name="phone" v-if="isManager && configStore.features.legacyPhone"></el-tab-pane>
				<el-tab-pane label="池塘" name="pool" v-if="isManager"></el-tab-pane>
				<el-tab-pane label="我的电销" name="claim"></el-tab-pane>
				<el-tab-pane label="已成交" name="dealt"></el-tab-pane>
			</el-tabs>
			<el-table v-if="tab !== 'phone'" :data="rows" size="small" max-height="420" :empty-text="emptyText" @expand-change="onExpand">
				<!-- 池塘: 展开行看全部拨打历史,判断要不要领取 -->
				<el-table-column type="expand" v-if="tab === 'pool'">
					<template slot-scope="s">
						<div class="tsd-expand" v-loading="expandLoadingId === s.row.receiptId">
							<div v-if="histCache[s.row.receiptId] && !histCache[s.row.receiptId].length" class="tsd-nocall">还没有拨打记录</div>
							<div v-for="h in (histCache[s.row.receiptId] || [])" :key="h.id" class="tsd-hist-line">
								<span class="tsd-hist-time">{{ fmtTime(h.createdTime) }}</span>
								<span class="tsd-hist-caller">{{ h.callerName || '-' }}</span>
								<span :class="h.connected ? 'tsd-hist-yes' : 'tsd-hist-no'">{{ h.connected ? '打通' : '未打通' }}</span>
								<span v-if="h.dealt" class="tsd-hist-dealt">成交</span>
								<span v-else-if="h.intent" class="tsd-hist-intent">意向{{ h.intent }}</span>
								<span class="tsd-hist-content">{{ h.content || '未填内容' }}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="买家名称" min-width="100">
					<template slot-scope="s">{{ s.row.buyerName }}</template>
				</el-table-column>
				<el-table-column label="电话" min-width="110">
					<template slot-scope="s">
						<span class="tsd-phone" @click="copyPhone(s.row.phone)">{{ s.row.phone }}</span>
					</template>
				</el-table-column>
				<el-table-column label="接待人" min-width="80">
					<template slot-scope="s">{{ s.row.salespersonName || '-' }}</template>
				</el-table-column>
				<el-table-column label="金额" min-width="90">
					<template slot-scope="s">{{ s.row.amount }} {{ s.row.fiat }}</template>
				</el-table-column>
				<el-table-column label="订单状态" min-width="80">
					<template slot-scope="s">
						<span :class="s.row.flowStatus === -1 ? 'tsd-st-cancel' : ''">{{ flowText(s.row.flowStatus) }}</span>
					</template>
				</el-table-column>
				<el-table-column label="拨打情况" min-width="150">
					<template slot-scope="s">
						<span v-if="s.row.callCount">{{ s.row.callCount }}次 · 最近 {{ s.row.lastCallerName }}<span v-if="s.row.lastIntent"> · 意向{{ s.row.lastIntent }}</span></span>
						<span v-else class="tsd-nocall">未拨打</span>
					</template>
				</el-table-column>
				<!-- 客户备注/微信: 客户管理里填的,电销拨打前可见风险提示 -->
				<el-table-column label="客户备注" min-width="180">
					<template slot-scope="s">
						<template v-if="s.row.customerRemark || s.row.customerWechat">
							<div v-if="s.row.customerRemark" class="tsd-remark"><i class="el-icon-warning-outline"></i> {{ s.row.customerRemark }}</div>
							<div v-if="s.row.customerWechat" class="tsd-remark tsd-remark-wx">微信: {{ s.row.customerWechat }}</div>
						</template>
						<span v-else class="tsd-nocall">-</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="190">
					<template slot-scope="s">
						<!-- 池塘(仅管理员可见): 分配给业务员(拨打历史点行首箭头展开) -->
						<template v-if="tab === 'pool'">
							<el-button type="text" size="mini" @click="openAssign(s.row)">分配</el-button>
						</template>
						<!-- 我的电销: 记录电话/退回/历史 -->
						<template v-else-if="tab === 'claim'">
							<el-button type="text" size="mini" @click="openCall(s.row)">记录电话</el-button>
							<el-button type="text" size="mini" class="tsd-danger" @click="doRelease(s.row)">退回池塘</el-button>
							<el-button type="text" size="mini" v-if="s.row.callCount" @click="openHistory(s.row)">历史</el-button>
						</template>
						<!-- 已成交: 看记录,也可丢回池塘继续二次电销 -->
						<template v-else>
							<el-button type="text" size="mini" @click="openHistory(s.row)">记录</el-button>
							<el-button type="text" size="mini" class="tsd-danger" @click="doRelease(s.row)">丢回池塘</el-button>
						</template>
					</template>
				</el-table-column>
			</el-table>

			<!-- 电话会话(老聊天库): 按人聚合,展开看该人的私聊会话;已读/收藏/备注按IM用户各自记录,查看记录自动标已读 -->
			<div v-if="tab === 'phone'" class="tsd-phone-bar">
				<el-radio-group v-model="phoneFilter" size="mini" @change="onPhoneFilter()">
					<el-radio-button label="all">全部</el-radio-button>
					<el-radio-button label="unread">未读</el-radio-button>
					<el-radio-button label="fav">收藏</el-radio-button>
				</el-radio-group>
				<el-button size="mini" icon="el-icon-refresh" :loading="phoneRefreshing" @click="onPhoneRefresh()">刷新老库数据</el-button>
			</div>
			<el-table v-if="tab === 'phone' && phoneFilter !== 'fav'" :data="rows" size="small" max-height="420" :empty-text="phoneEmptyText" @expand-change="onPhoneExpand">
				<el-table-column type="expand">
					<template slot-scope="s">
						<div class="tsd-expand" v-loading="phoneExpandLoadingId === s.row.uid">
							<div v-if="phoneHistCache[s.row.uid] && !phoneHistCache[s.row.uid].length" class="tsd-nocall">没有含电话的私聊会话</div>
							<div v-for="c in (phoneHistCache[s.row.uid] || [])" :key="c.b" class="tsd-hist-line">
								<span class="tsd-hist-time">{{ fmtTime(c.lastTime) }}</span>
								<el-tag size="mini" :type="c.read ? 'info' : 'danger'">{{ c.read ? '已读' : '未读' }}</el-tag>
								<span class="tsd-hist-caller">{{ c.bName || c.b }}</span>
								<span v-if="c.region" class="tsd-hist-region">{{ c.region }}</span>
								<span class="tsd-hist-content">{{ c.cnt }}条含电话</span>
								<span v-if="c.remark" class="tsd-remark-text">备注: {{ c.remark }}</span>
								<el-button type="text" size="mini" @click="openPhoneMsgs(s.row, c)">查看记录</el-button>
								<el-button type="text" size="mini" :class="c.fav ? 'tsd-fav-badge' : ''" @click="togglePhoneFav(s.row, c)">{{ c.fav ? '★已收藏' : '☆收藏' }}</el-button>
								<el-button type="text" size="mini" @click="editPhoneRemark(s.row, c)">备注</el-button>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="用户" min-width="160">
					<template slot-scope="s">{{ s.row.name }}</template>
				</el-table-column>
				<el-table-column label="地区" min-width="110">
					<template slot-scope="s">{{ s.row.region || '-' }}</template>
				</el-table-column>
				<el-table-column label="聊天对象" width="80">
					<template slot-scope="s">{{ s.row.partners }}人</template>
				</el-table-column>
				<el-table-column label="未读" width="60">
					<template slot-scope="s">
						<span :class="s.row.unread ? 'tsd-unread-badge' : 'tsd-nocall'">{{ s.row.unread || 0 }}</span>
					</template>
				</el-table-column>
				<el-table-column label="收藏" width="60">
					<template slot-scope="s">
						<span :class="s.row.fav ? 'tsd-fav-badge' : 'tsd-nocall'">{{ s.row.fav || 0 }}</span>
					</template>
				</el-table-column>
				<el-table-column label="含电话消息" width="100">
					<template slot-scope="s">{{ s.row.cnt }}条</template>
				</el-table-column>
				<el-table-column label="最近时间" width="110">
					<template slot-scope="s">{{ fmtTime(s.row.lastTime) }}</template>
				</el-table-column>
			</el-table>
			<!-- 收藏视图: 单条会话维度的收藏列表(不按人聚合),可直接看记录/改备注/取消收藏 -->
			<el-table v-if="tab === 'phone' && phoneFilter === 'fav'" :data="rows" size="small" max-height="420" :empty-text="phoneEmptyText">
				<el-table-column label="会话" min-width="230">
					<template slot-scope="s">
						<el-tag size="mini" :type="s.row.read ? 'info' : 'danger'" style="margin-right:6px">{{ s.row.read ? '已读' : '未读' }}</el-tag>
						{{ s.row.aName || s.row.a }} ⇄ {{ s.row.bName || s.row.b }}
					</template>
				</el-table-column>
				<el-table-column label="含电话" width="70">
					<template slot-scope="s">{{ s.row.cnt }}条</template>
				</el-table-column>
				<el-table-column label="地区" min-width="140">
					<template slot-scope="s">{{ s.row.aRegion || '-' }} / {{ s.row.bRegion || '-' }}</template>
				</el-table-column>
				<el-table-column label="最近" width="100">
					<template slot-scope="s">{{ fmtTime(s.row.lastTime) }}</template>
				</el-table-column>
				<el-table-column label="备注" min-width="140">
					<template slot-scope="s">
						<span class="tsd-remark-text" style="max-width:none">{{ s.row.remark || '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="180">
					<template slot-scope="s">
						<el-button type="text" size="mini" @click="openPhoneMsgs({ name: s.row.aName, unread: 0 }, s.row)">查看记录</el-button>
						<el-button type="text" size="mini" @click="editPhoneRemark(s.row, s.row)">备注</el-button>
						<el-button type="text" size="mini" class="tsd-danger" @click="togglePhoneFav(s.row, s.row)">取消收藏</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination v-if="tab === 'phone' && phoneFilter !== 'fav' && phoneTotal > 0" style="margin-top:10px;text-align:right"
				layout="total, prev, pager, next" :current-page="phonePage" :page-size="phonePageSize" :total="phoneTotal"
				@current-change="onPhonePage"></el-pagination>
		</div>

		<!-- 管理员分配弹窗 -->
		<el-dialog title="分配电销线索" :visible.sync="assignDlg.visible" width="400px" append-to-body :close-on-click-modal="false">
			<div class="tsd-call-head">
				<span>买家：{{ assignDlg.buyerName }}</span>
				<span class="tsd-phone">{{ assignDlg.phone }}</span>
			</div>
			<el-form label-width="90px" size="small">
				<el-form-item label="分配给" v-loading="assignDlg.loading">
					<el-select v-model="assignDlg.assigneeId" placeholder="选择业务员" style="width:100%">
						<el-option v-for="m in assignDlg.members" :key="m.id" :value="m.id"
							:label="m.name + '（已分配' + m.assigned + ' 成交' + m.dealt + ' 率' + m.dealRate + '%）'">
							<span class="tsd-opt-line">
								<span>{{ m.name }}</span>
								<span class="tsd-opt-stat">已分配{{ m.assigned }} · 成交{{ m.dealt }} · 率{{ m.dealRate }}%</span>
							</span>
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button size="small" @click="assignDlg.visible = false">取消</el-button>
				<el-button size="small" type="primary" :loading="assignDlg.saving" @click="saveAssign()">确认分配</el-button>
			</div>
		</el-dialog>

		<!-- 记录电话弹窗 -->
		<el-dialog title="记录电话" :visible.sync="callDlg.visible" width="440px" append-to-body :close-on-click-modal="false">
			<div class="tsd-call-head">
				<span>买家：{{ callDlg.buyerName }}</span>
				<span class="tsd-phone" @click="copyPhone(callDlg.phone)">{{ callDlg.phone }}</span>
			</div>
			<el-form label-width="90px" size="small">
				<el-form-item label="是否打通">
					<el-switch v-model="callDlg.form.connected" active-color="#1677ff"></el-switch>
				</el-form-item>
				<el-form-item label="是否成交">
					<el-radio-group v-model="callDlg.form.dealt">
						<el-radio :label="true">已成交</el-radio>
						<el-radio :label="false">未成交</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="客户意向" v-if="!callDlg.form.dealt">
					<el-radio-group v-model="callDlg.form.intent">
						<el-radio label="高">高</el-radio>
						<el-radio label="中">中</el-radio>
						<el-radio label="低">低</el-radio>
						<el-radio label="无">无</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="谈话内容">
					<el-input type="textarea" :rows="3" maxlength="500" show-word-limit
						v-model="callDlg.form.content" placeholder="大概聊了什么，方便下次同事接手"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button size="small" @click="callDlg.visible = false">取消</el-button>
				<el-button size="small" type="primary" :loading="callDlg.saving" @click="saveCall()">保存记录</el-button>
			</div>
		</el-dialog>

		<!-- 聊天记录弹窗(默认完整历史便于分析,可切只看含电话) -->
		<el-dialog title="聊天记录" :visible.sync="phoneMsgDlg.visible" width="680px" append-to-body :close-on-click-modal="false">
			<div class="tsd-call-head">
				<span>{{ phoneMsgDlg.title }}</span>
				<el-switch v-model="phoneMsgDlg.onlyPhone" active-text="只看含电话" style="margin-left:auto" @change="reloadPhoneMsgs()"></el-switch>
			</div>
			<el-table :data="phoneMsgDlg.list" size="small" v-loading="phoneMsgDlg.loading" max-height="400" empty-text="暂无记录">
				<el-table-column label="时间" width="110">
					<template slot-scope="s">{{ fmtTime(s.row.time) }}</template>
				</el-table-column>
				<el-table-column label="发送人" width="160" prop="senderName" show-overflow-tooltip></el-table-column>
				<el-table-column :label="phoneMsgDlg.onlyPhone ? '消息内容(含电话)' : '消息内容'" min-width="260">
					<template slot-scope="s">
						<!-- 内容解析: 图片链接出缩略图(点击放大,可关闭),其他链接可点开 -->
						<template v-for="(seg, si) in parseMsgSegs(s.row.content)">
							<img v-if="seg.img" :key="'i' + si" :src="seg.url"
								class="tsd-msg-img" @click="imgViewer.url = seg.url; imgViewer.visible = true">
							<a v-else-if="seg.url" :key="'l' + si" :href="seg.url" target="_blank" rel="noopener" class="tsd-msg-link">{{ seg.url }}</a>
							<span v-else :key="'t' + si" class="tsd-hist-content">{{ seg.text }}</span>
						</template>
					</template>
				</el-table-column>
			</el-table>
			<div class="tsd-tip" style="margin-top:8px"><i class="el-icon-info"></i><span>按时间正序展示,最多最近1000条；图片点击可放大查看。</span></div>
		</el-dialog>

		<!-- 图片查看器(append-to-body挂到body层,不会被嵌套弹窗挡住;点遮罩或右上角✕关闭) -->
		<el-dialog :visible.sync="imgViewer.visible" append-to-body fullscreen custom-class="tsd-img-dialog">
			<img :src="imgViewer.url" class="tsd-img-full">
		</el-dialog>

		<!-- 历史记录弹窗 -->
		<el-dialog title="拨打历史" :visible.sync="histDlg.visible" width="620px" append-to-body :close-on-click-modal="false">
			<el-table :data="histDlg.list" size="small" v-loading="histDlg.loading" max-height="400" empty-text="暂无记录">
				<el-table-column label="时间" width="140">
					<template slot-scope="s">{{ fmtTime(s.row.createdTime) }}</template>
				</el-table-column>
				<el-table-column label="拨打人" prop="callerName" width="90"></el-table-column>
				<el-table-column label="打通" width="60">
					<template slot-scope="s">{{ s.row.connected ? '是' : '否' }}</template>
				</el-table-column>
				<el-table-column label="意向" width="60">
					<template slot-scope="s">{{ s.row.dealt ? '成交' : (s.row.intent || '-') }}</template>
				</el-table-column>
				<el-table-column label="谈话内容" prop="content" min-width="200" show-overflow-tooltip></el-table-column>
			</el-table>
		</el-dialog>
	</el-dialog>
</template>

<script>
import bizApi from "../../api/bizApi.js";

export default {
	name: "telesalesDialog",
	props: {
		visible: { type: Boolean, default: false },
		groupId: { type: [Number, String], default: null },
		isManager: { type: Boolean, default: false },
		// 独立页模式(/telesales): 弹窗近全屏展示,groupId可不传(后端不限群)
		pageMode: { type: Boolean, default: false }
	},
	data() {
		return {
			loading: false,
			tab: 'pool',
			rows: [],
			claimingId: null,
			expandLoadingId: null,
			histCache: {}, // receiptId -> 拨打历史(展开行按需加载)
			assignDlg: {
				visible: false, loading: false, saving: false,
				receiptId: null, buyerName: '', phone: '',
				members: [], assigneeId: null
			},
			callDlg: {
				visible: false, saving: false,
				receiptId: null, buyerName: '', phone: '',
				form: { connected: true, dealt: false, intent: '', content: '' }
			},
			histDlg: { visible: false, loading: false, list: [] },
			phoneMsgDlg: { visible: false, loading: false, list: [], title: '', a: null, b: null, onlyPhone: false },
			phoneExpandLoadingId: null,
			phoneHistCache: {}, // uid -> 该人的含电话私聊会话(展开行按需加载)
			phoneFilter: 'all', // all全部 unread未读 fav收藏
			phoneRefreshing: false,
			imgViewer: { visible: false, url: '' },
			phonePage: 1,
			phonePageSize: 20,
			phoneTotal: 0
		};
	},
	computed: {
		phoneEmptyText() {
			if (this.phoneFilter === 'unread') return '没有未读的会话，都看完啦';
			if (this.phoneFilter === 'fav') return '还没有收藏的会话';
			return '暂无含电话的私聊用户';
		},
		emptyText() {
			if (this.tab === 'phone') return '暂无含电话的会话';
			if (this.tab === 'pool') return '池塘暂无待分配的线索';
			if (this.tab === 'claim') return this.isManager ? '还没有分配中的线索' : '管理员还没有给你分配线索';
			return '暂无成交记录';
		}
	},
	watch: {
		visible(v) {
			if (v) {
				// 业务员看不到池塘,默认落在我的电销
				this.tab = this.isManager ? 'pool' : 'claim';
				this.load();
			}
		}
	},
	methods: {
		load() {
			// 业务员无池塘权限,兼容切换
			if (this.tab === 'pool' && !this.isManager) {
				this.tab = 'claim';
			}
			this.loading = true;
			this.histCache = {};
			if (this.tab === 'phone') {
				this.phoneHistCache = {};
				if (this.phoneFilter === 'fav') {
					// 收藏列表: 单条会话维度,不分页
					bizApi.legacyPhoneFavs().then((list) => {
						this.rows = list || [];
						this.phoneTotal = this.rows.length;
					}).catch((e) => {
						this.$message.error(e.message || '加载失败');
					}).finally(() => {
						this.loading = false;
					});
					return;
				}
				bizApi.legacyPhoneUsers(this.phonePage, this.phonePageSize, this.phoneFilter).then((res) => {
					this.rows = (res && res.list) || [];
					this.phoneTotal = (res && res.total) || 0;
				}).catch((e) => {
					this.$message.error(e.message || '加载失败');
				}).finally(() => {
					this.loading = false;
				});
				return;
			}
			const req = this.tab === 'pool'
				? bizApi.telesalesPool(this.groupId)
				: bizApi.telesalesMine(this.groupId, this.tab);
			req.then((list) => {
				this.rows = list || [];
			}).catch((e) => {
				this.$message.error(e.message || '加载失败');
			}).finally(() => {
				this.loading = false;
			});
		},
		onTabClick() {
			this.phonePage = 1;
			this.load();
		},
		onPhonePage(p) {
			this.phonePage = p;
			this.load();
		},
		onPhoneExpand(row, expandedRows) {
			const expanded = expandedRows.some((r) => r.uid === row.uid);
			if (!expanded || this.phoneHistCache[row.uid]) {
				return;
			}
			this.phoneExpandLoadingId = row.uid;
			bizApi.legacyPhoneConvs(row.uid).then((list) => {
				this.$set(this.phoneHistCache, row.uid, list || []);
			}).catch((e) => {
				this.$message.error(e.message || '加载会话失败');
			}).finally(() => {
				this.phoneExpandLoadingId = null;
			});
		},
		onPhoneFilter() {
			this.phonePage = 1;
			this.load();
		},
		onPhoneRefresh() {
			this.phoneRefreshing = true;
			bizApi.legacyPhoneRefresh().then((res) => {
				this.$message.success('已刷新老库数据(含电话会话' + ((res && res.convs) || 0) + '个)');
				this.phonePage = 1;
				this.load();
			}).catch((e) => {
				this.$message.error(e.message || '刷新失败');
			}).finally(() => {
				this.phoneRefreshing = false;
			});
		},
		markPhoneConv(conv, data) {
			bizApi.legacyPhoneMark(conv.a, conv.b, data).catch((e) => {
				this.$message.error(e.message || '标记失败');
			});
		},
		togglePhoneFav(row, conv) {
			conv.fav = !conv.fav;
			if (this.phoneFilter === 'fav') {
				// 收藏列表里取消收藏直接从列表移除
				if (!conv.fav) {
					this.rows = this.rows.filter((r) => r !== conv);
					this.phoneTotal = this.rows.length;
				}
			} else {
				row.fav = Math.max(0, (row.fav || 0) + (conv.fav ? 1 : -1));
			}
			this.markPhoneConv(conv, { fav: conv.fav ? 1 : 0 });
		},
		editPhoneRemark(row, conv) {
			this.$prompt('给该会话写备注(方便后续跟进)', '备注', {
				confirmButtonText: '保存', cancelButtonText: '取消',
				inputValue: conv.remark || '', inputPlaceholder: '例如: 客户意向高,下周跟进',
				inputValidator: (v) => !v || v.length <= 500 || '备注不能超过500字'
			}).then(({ value }) => {
				conv.remark = (value || '').trim();
				this.markPhoneConv(conv, { remark: conv.remark });
			}).catch(() => { });
		},
		onExpand(row, expandedRows) {
			const expanded = expandedRows.some((r) => r.receiptId === row.receiptId);
			if (!expanded || this.histCache[row.receiptId]) {
				return;
			}
			this.expandLoadingId = row.receiptId;
			bizApi.telesalesHistory(row.receiptId).then((list) => {
				this.$set(this.histCache, row.receiptId, list || []);
			}).catch((e) => {
				this.$message.error(e.message || '加载历史失败');
			}).finally(() => {
				this.expandLoadingId = null;
			});
		},
		openAssign(row) {
			this.assignDlg.receiptId = row.receiptId;
			this.assignDlg.buyerName = row.buyerName;
			this.assignDlg.phone = row.phone;
			this.assignDlg.members = [];
			this.assignDlg.assigneeId = null;
			this.assignDlg.visible = true;
			this.assignDlg.loading = true;
			bizApi.telesalesMembers(row.receiptId).then((list) => {
				this.assignDlg.members = list || [];
			}).catch((e) => {
				this.$message.error(e.message || '加载候选失败');
			}).finally(() => {
				this.assignDlg.loading = false;
			});
		},
		saveAssign() {
			if (!this.assignDlg.assigneeId) {
				this.$message.warning('请选择要分配的业务员');
				return;
			}
			this.assignDlg.saving = true;
			bizApi.telesalesAssign(this.assignDlg.receiptId, this.assignDlg.assigneeId).then(() => {
				this.$message.success('已分配，对方可在「我的电销」看到');
				this.assignDlg.visible = false;
				this.load();
			}).catch((e) => {
				this.$message.error(e.message || '分配失败');
			}).finally(() => {
				this.assignDlg.saving = false;
			});
		},
		doClaim(row) {
			this.claimingId = row.receiptId;
			bizApi.telesalesClaim(row.receiptId).then(() => {
				this.$message.success('已领取，到「我的电销」拨打吧');
				this.load();
			}).catch((e) => {
				this.$message.error(e.message || '领取失败');
				this.load();
			}).finally(() => {
				this.claimingId = null;
			});
		},
		doRelease(row) {
			const tip = this.tab === 'dealt'
				? '丢回后该客户重新进入池塘，可再分配给其他同事，确定丢回？'
				: '退回后该线索回到池塘，可再分配给其他同事，确定退回池塘？';
			this.$confirm(tip, '退回线索', {
				type: 'warning', confirmButtonText: '退回', cancelButtonText: '取消'
			}).then(() => {
				bizApi.telesalesRelease(row.receiptId).then(() => {
					this.$message.success('已退回池塘');
					this.load();
				}).catch((e) => {
					this.$message.error(e.message || '退回失败');
				});
			}).catch(() => { });
		},
		flowText(st) {
			const map = { '-1': '已取消', 0: '待分配', 1: '待确认收款', 2: '待放行', 3: '已放行', 4: '待财务确认', 5: '完结' };
			return map[st] != null ? map[st] : '-';
		},
		fmtTime(t) {
			if (!t) return '-';
			const d = new Date(t);
			const p = (n) => (n < 10 ? '0' + n : n);
			return `${d.getMonth() + 1}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
		},
		parseMsgSegs(content) {
			// 把消息内容拆成 文本/图片/链接 片段: 老库图片消息就是纯OSS URL,也有文字+链接混排
			if (!content) return [];
			const segs = [];
			const re = /https?:\/\/[^\s一-龥，。！？、；："“”]+/g;
			let last = 0;
			let m;
			while ((m = re.exec(content)) !== null) {
				if (m.index > last) {
					segs.push({ text: content.slice(last, m.index) });
				}
				const url = m[0];
				const isImg = /\.(jpg|jpeg|png|gif|webp)([?#].*)?$/i.test(url);
				segs.push({ url, img: isImg });
				last = m.index + url.length;
			}
			if (last < content.length) {
				segs.push({ text: content.slice(last) });
			}
			return segs;
		},
		openCall(row) {
			this.callDlg.receiptId = row.receiptId;
			this.callDlg.buyerName = row.buyerName;
			this.callDlg.phone = row.phone;
			this.callDlg.form = { connected: true, dealt: false, intent: '', content: '' };
			this.callDlg.visible = true;
		},
		saveCall() {
			const f = this.callDlg.form;
			if (!f.dealt && !f.intent) {
				this.$message.warning('未成交时请选择客户意向');
				return;
			}
			this.callDlg.saving = true;
			bizApi.telesalesCall({
				receiptId: this.callDlg.receiptId,
				phone: this.callDlg.phone,
				connected: f.connected,
				dealt: f.dealt,
				intent: f.dealt ? '' : f.intent,
				content: f.content
			}).then(() => {
				this.$message.success(f.dealt ? '已登记，该线索保留在你的已成交列表' : '已登记，线索仍留在「我的电销」继续跟进');
				this.callDlg.visible = false;
				this.load();
			}).catch((e) => {
				this.$message.error(e.message || '保存失败');
			}).finally(() => {
				this.callDlg.saving = false;
			});
		},
		openPhoneMsgs(row, conv) {
			// 查看记录即视为已读,同步减该人的未读数
			if (!conv.read) {
				conv.read = true;
				if (row.unread > 0) {
					row.unread--;
				}
				this.markPhoneConv(conv, { read: 1 });
			}
			this.phoneMsgDlg.visible = true;
			this.phoneMsgDlg.title = (row.name || row.uid) + ' ⇄ ' + (conv.bName || conv.b);
			this.phoneMsgDlg.a = conv.a;
			this.phoneMsgDlg.b = conv.b;
			this.phoneMsgDlg.onlyPhone = false;
			this.reloadPhoneMsgs();
		},
		reloadPhoneMsgs() {
			this.phoneMsgDlg.loading = true;
			this.phoneMsgDlg.list = [];
			bizApi.legacyPhoneMsgs(this.phoneMsgDlg.a, this.phoneMsgDlg.b, this.phoneMsgDlg.onlyPhone).then((list) => {
				this.phoneMsgDlg.list = list || [];
			}).catch((e) => {
				this.$message.error(e.message || '加载失败');
			}).finally(() => {
				this.phoneMsgDlg.loading = false;
			});
		},
		openHistory(row) {
			this.histDlg.visible = true;
			this.histDlg.loading = true;
			this.histDlg.list = [];
			bizApi.telesalesHistory(row.receiptId).then((list) => {
				this.histDlg.list = list || [];
			}).catch((e) => {
				this.$message.error(e.message || '加载失败');
			}).finally(() => {
				this.histDlg.loading = false;
			});
		},
		copyPhone(phone) {
			if (!phone) return;
			const ta = document.createElement('textarea');
			ta.value = phone;
			document.body.appendChild(ta);
			ta.select();
			try {
				document.execCommand('copy');
				this.$message.success('号码已复制');
			} catch (e) {
				this.$message.error('复制失败');
			}
			document.body.removeChild(ta);
		},
		onClose() {
			this.$emit('close');
		}
	}
};
</script>

<style lang="scss" scoped>
.tsd-body {
	min-height: 220px;
}
.tsd-tip {
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 8px 10px;
	margin-bottom: 6px;
	background: #f0f7ff;
	border-radius: 6px;
	color: #555;
	font-size: 12px;
	i { color: #1677ff; }
}
.tsd-phone {
	color: #1677ff;
	cursor: pointer;
	&:hover { text-decoration: underline; }
}
.tsd-nocall { color: #999; }
.tsd-remark {
	color: #e6a23c;
	word-break: break-all;
	line-height: 1.5;
}
.tsd-remark .el-icon-warning-outline { color: #e6a23c; }
.tsd-remark-wx { color: #409eff; }
.tsd-expand {
	padding: 6px 12px 6px 40px;
	min-height: 28px;
}
.tsd-hist-line {
	display: flex;
	align-items: baseline;
	gap: 10px;
	padding: 4px 0;
	font-size: 12px;
	border-bottom: 1px dashed #eee;
	&:last-child { border-bottom: none; }
}
.tsd-hist-time { color: #999; flex-shrink: 0; }
.tsd-hist-caller { color: #1677ff; flex-shrink: 0; }
.tsd-hist-yes { color: #67c23a; flex-shrink: 0; }
.tsd-hist-no { color: #f56c6c; flex-shrink: 0; }
.tsd-hist-dealt { color: #67c23a; font-weight: bold; flex-shrink: 0; }
.tsd-hist-intent { color: #e6a23c; flex-shrink: 0; }
.tsd-hist-content { color: #555; word-break: break-all; }
.tsd-st-cancel { color: #f56c6c; }
.tsd-danger { color: #f56c6c; }
.tsd-phone-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
}
.tsd-unread-badge { color: #f56c6c; font-weight: bold; }
.tsd-fav-badge { color: #e6a23c; font-weight: bold; }
.tsd-remark-text { color: #e6a23c; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.tsd-msg-img {
	max-width: 110px;
	max-height: 110px;
	margin: 2px 6px 2px 0;
	border-radius: 4px;
	cursor: pointer;
	vertical-align: middle;
	&:hover { opacity: .85; }
}
.tsd-msg-link { color: #1677ff; word-break: break-all; }
.tsd-hist-region { color: #67c23a; font-size: 12px; margin-left: 2px; }
.tsd-call-head {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 12px;
	font-size: 14px;
}
.tsd-opt-line {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}
.tsd-opt-stat {
	color: #909399;
	font-size: 12px;
}
</style>

<!-- 图片查看器样式: 必须非scoped——append-to-body弹窗挂在body下,节点不带本组件scoped标记 -->
<style lang="scss">
.tsd-img-dialog {
	background: transparent !important;
	box-shadow: none;
	margin: 0 !important;
	display: flex;
	flex-direction: column;
	.el-dialog__header {
		padding: 14px 18px 0;
		position: relative;
		z-index: 1;
	}
	.el-dialog__headerbtn .el-dialog__close {
		color: #fff;
		font-size: 30px;
		&:hover { color: #f56c6c; }
	}
	.el-dialog__body {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0;
		overflow: auto;
	}
}
/* 图片按原始尺寸居中展示,仅当超过屏幕时按比例缩小,不拉伸不铺满 */
.tsd-img-full {
	max-width: 90vw;
	max-height: 88vh;
	width: auto;
	height: auto;
	box-shadow: 0 4px 30px rgba(0, 0, 0, .6);
}
</style>
